var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.message.length > 1,"dismissible":_vm.dismissable,"variant":_vm.variant}},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "+_vm._s(_vm.message)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }